export interface Authentication {
  authenticationCompleted: boolean,
  authenticationFailed: boolean,
}

export enum AuthenticationActions {
  AUTHENTICATION_COMPLETED = '@@authentication/AUTHENTICATION_COMPLETED',
  AUTHENTICATION_FAILED = '@@authentication/AUTHENTICATION_FAILED'
}
